import React, { Component } from "react";
import auth from "../../auth/authHelper";
import classnames from "classnames";
import { Redirect } from "react-router-dom";
import { signin } from "../../auth/authApi.js";
import styles from "./SignIn.scss";

class SignIn extends Component {
  state = {
    email: "",
    password: "",
    error: "",
    redirectToReferrer: false
  };

  componentDidMount = () => {
    console.log("this.props.history: ", this.props.history.location.state.from);
  }

  clickSubmit = e => {
    e.preventDefault();
    const user = {
      email: this.state.email || undefined,
      password: this.state.password || undefined
    };

    signin(user).then(data => {
      if (data.success === false) {
        this.setState({ error: data.msg });
      } else {
        auth.authenticate(data, () => {
          localStorage.setItem("jwt", data.token);
          this.setState({ redirectToReferrer: true });
        });
      }
    });
  };

  handleChange = name => event => {
    this.setState({ [name]: event.target.value });
  };

  render() {
    if (auth.isAuthenticated()) {
      let redirectPath =
        this.props.history.location.state.from.pathname +
        this.props.history.location.state.from.search;
      return <Redirect to={redirectPath} />;
    }
    const { from } = this.props.location.state || {
      from: {
        pathname: "/"
      }
    };
    const { redirectToReferrer } = this.state;
    if (redirectToReferrer) {
      return <Redirect to={from} />;
    }

    return (
      <div className="container">
        <div className={classnames("container", styles.contain)}>
          <form>
            <h5>SIGN IN</h5>
            <div className="form-group">
              <label for="exampleInputEmail1">Email address</label>
              <input
                type="email"
                className="form-control"
                id="exampleInputEmail1"
                aria-describedby="emailHelp"
                placeholder="Enter email"
                value={this.state.email}
                onChange={this.handleChange("email")}
              />
              <small id="emailHelp" className="form-text text-muted">
                We'll never share your email with anyone else.
              </small>
            </div>
            <div className="form-group">
              <label for="exampleInputPassword1">Password</label>
              <input
                type="password"
                className="form-control"
                id="exampleInputPassword1"
                placeholder="Password"
                value={this.state.password}
                onChange={this.handleChange("password")}
              />
            </div>
            {this.state.error && (
              <div className={styles.error}>
                <p>{this.state.error}</p>
              </div>
            )}
            <button className="btn btn-light" onClick={this.clickSubmit}>
              sign in
            </button>
          </form>
        </div>
      </div>
    );
  }
}

export default SignIn;



// WEBPACK FOOTER //
// ./src/components/pages/Admin/SignIn.js